import Immutable from 'immutable';
import { handleActions } from 'redux-actions';

const MaintenanceFixingState = Immutable.fromJS({
    request: {
        target: null,
        mcase: null,
        card: null,
        type: null,
        queuing: false,

        sortOrders: {
            orderby: undefined,
            code: { by: "code", asc: undefined },
            status: { by: "status", asc: undefined },
            owner: { by: "owner", asc: undefined },
            unit: { by: "unit", asc: undefined },
            pantFixed: { by: "pantFixed", asc: undefined },
            clothesFixed: { by: "clothesFixed", asc: undefined }
        },
    },
    response: {
        cases: [],
        cards: [],
        details: [],
        photos: [],
        card: null,
        category: null,
        show: false,
    },
    options: {},
    alert: {
        style: null,
        message: null
    },
    isLoadingPage: false,
});

const maintenanceFixingReducer = handleActions({

    QUEUE_POST_PHOTO: (state, { payload }) => {
        let resp = state.get('response');
        resp = resp.set('card', payload.data.card);
        resp = resp.set('photos', payload.data.photos);

        return state.merge({
            response: resp,
            alert: {
                style: payload.alertStyle,
                message: payload.displayMessage
            },
            isLoadingPage: false
        })
    },

    MARK_POP_POST_PHOTO: (state, { payload }) => {
        let requestModel = state.get('request');
        return state.merge({
            request: requestModel.set('queuing', false)
        })
    },

    MARK_QUEUE_POST_PHOTO: (state, { payload }) => {
        let requestModel = state.get('request');
        return state.merge({
            request: requestModel.set('queuing', true),
            alert: {
                style: null,
                message: null
            }
        })
    },

    FIND_AUDITABLE_MAINTENANCE_DETAILS: (state, { payload }) => {
        let respObject = state.get('response');
        respObject =  respObject.set("card", payload.data.card);
        respObject =  respObject.set("details", payload.data.details);
        return state.merge({
            response: respObject,
        })
    },

    ASSIGN_AUDITING_MCARD_TARGET: (state, { payload }) => {
        let req = state.get('request');
        req = req.set("card", payload.card.id);     // 為什麼是card.id? 怕改壞，先不動..Orz
        req = req.set("type", payload.type);

        let resp = state.get("response");
        resp = resp.set("card", payload.card);

        return state.merge({
            request: req,
            response: resp,
        })
    },

    ASSIGN_AUDITING_MCASE_TARGET: (state, { payload }) => {
        let req = state.get('request');
        req = req.set("target", payload.id);
        req = req.set("mcase", payload);
        return state.merge({
            request: req,
        })
    },

    //Request
    FIND_AUDITABLE_MCASES: (state, { payload }) => {
        let respObject = state.get('response');
        return state.merge({
            response: respObject.set("cases", payload.data),
        })
    },

    FIND_AUDITABLE_MAINTENANCE_CARDS: (state, { payload }) => {
        let respObject = state.get('response');
        return state.merge({
            response: respObject.set("cards", payload.data),
        })
    },

    FIND_SORTED_AUDITABLE_MAINTENANCE_CARDS: (state, { payload }) => {
        state = state.updateIn(['request', 'sortOrders', payload.order.get('by'), 'asc'],
        value => value == undefined ? false : !value);
        state = state.updateIn(['response', 'cards'], () => payload.cards);
        state = state.updateIn(['request', 'sortOrders', 'orderby'], () => payload.order.get('by'));

        return state.merge();
    },

    CLEAN_AUDITING_ALERT: (state, { payload }) => {
        return state.merge({
          alert: {
            style: null,
            message: null
          }
        })
    },

// 結尾加2為將「維修增補項目」改為「檢點增補項目」的程式
// copy from maintenanceFixingReducer 再調整
    SHOW_MAINTENANCE_MODIFY_COMPONENT_MODAL_2: (state, { payload }) => {
        let respObject = state.get('response');
        respObject = respObject.set("card", payload.card);
        respObject = respObject.set("category", payload.category);
        respObject = respObject.set("show", true);
        return state.merge({
            response: respObject,
        })
    },
    HIDE_MAINTENANCE_MODIFY_COMPONENT_MODAL_2: (state, { payload }) => {
        let respObject = state.get('response');
        respObject = respObject.set("category", null);
        respObject = respObject.set("show", false);
        return state.merge({
            response: respObject,
        })
    },
    ASSIGN_APPEND_CHECK_SET_2: (state, { payload }) => {
        let req = state.get('request');
        req = req.set("checkSet", payload);
        return state.merge({
            request: req,
        })
    },
    ASSIGN_APPEND_CHECK_ITEM_2: (state, { payload }) => {
        let req = state.get('request');
        req = req.set("checkItem", payload);
        return state.merge({
            request: req,
        })
    },

    ASSIGN_APPEND_CHECK_NOTE_2: (state, { payload }) => {
        let req = state.get('request');
        req = req.set("note", payload);
        return state.merge({
            request: req,
        })
    },

    FIND_FIXABLE_MAINTENANCE_DETAILS_2: (state, { payload }) => {
        let respObject = state.get('response');
        respObject = respObject.set("details", payload.data.details);
        respObject = respObject.set("card", payload.data.card);
        return state.merge({
            response: respObject,
        })
    },

    // 頁面 LOADING
    LOADING_PAGE_2: (state, { payload }) => {
        return state.merge({
            isLoadingPage: payload,
        })
    },

}, MaintenanceFixingState);

export default maintenanceFixingReducer;


// WEBPACK FOOTER //
// ./src/reducers/maintenanceAuditingReducer.js